export default __webpack_public_path__ + "auth-google.svg";